import React from 'react';
import { CheckCircle } from 'lucide-react';
export function Benefits() {
  return <section className="py-[50px] px-[15px] relative bg-gradient-to-br from-[#DC2626] to-[#991B1B]" data-id="element-34">
      <div className="container max-w-full mx-auto px-[15px] relative z-[2]" data-id="element-35">
        <div className="bg-gradient-to-r from-[#DC2626] to-[#991B1B] text-white p-[12px_20px] text-center font-[700] text-[18px] uppercase rounded-[8px] mb-[25px] shadow-[0_5px_15px_rgba(220,38,38,0.3)] w-full border border-[#FCA5A5]/30" data-id="element-36">
          The Knee Geometry Method exists for this
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-[15px]" data-id="element-37">
          <div className="bg-[rgba(255,255,255,0.95)] p-[20px] rounded-[8px] text-center shadow-[0_4px_10px_rgba(0,0,0,0.05)] border-b-[4px] border-[#10B981]" data-id="element-38">
            <CheckCircle className="text-[28px] text-[#10B981] mb-[12px] block mx-auto" data-id="element-39" />
            <div data-id="element-40">
              So you <strong data-id="element-41">stop guessing</strong> and start having real
              control over your knee.
            </div>
          </div>

          <div className="bg-[rgba(255,255,255,0.95)] p-[20px] rounded-[8px] text-center shadow-[0_4px_10px_rgba(0,0,0,0.05)] border-b-[4px] border-[#10B981]" data-id="element-42">
            <CheckCircle className="text-[28px] text-[#10B981] mb-[12px] block mx-auto" data-id="element-43" />
            <div data-id="element-44">
              A premium digital guide built for real people:{' '}
              <strong data-id="element-45">no gym required, no impact</strong> and no "push through
              it" culture.
            </div>
          </div>

          <div className="bg-[rgba(255,255,255,0.95)] p-[20px] rounded-[8px] text-center shadow-[0_4px_10px_rgba(0,0,0,0.05)] border-b-[4px] border-[#10B981]" data-id="element-46">
            <CheckCircle className="text-[28px] text-[#10B981] mb-[12px] block mx-auto" data-id="element-47" />
            <div data-id="element-48">
              A progressive 3-step system:{' '}
              <strong data-id="element-49">
                Reset the Angles + Lock in Stability + Train the Walk.
              </strong>
            </div>
          </div>

          <div className="bg-[rgba(255,255,255,0.95)] p-[20px] rounded-[8px] text-center shadow-[0_4px_10px_rgba(0,0,0,0.05)] border-b-[4px] border-[#10B981]" data-id="element-50">
            <CheckCircle className="text-[28px] text-[#10B981] mb-[12px] block mx-auto" data-id="element-51" />
            <div data-id="element-52">
              <strong data-id="element-53">Pain Traffic Light system (Green/Yellow/Red)</strong> that
              tells you exactly what to adjust when something flares up.
            </div>
          </div>
        </div>
      </div>
    </section>;
}